export const leaveTypeOptionapi = `
query allLeaveTypes{
  allLeaveTypes {
    id
    leavetype
  }
}
`;

export const leavePeriodOptionapi = `
query allPeriods{
  allPeriods {
    id
    period
  }
}
`;

export const employeeTypeOptionapi = `
query allEmployeeTypes{
  allEmployeeTypes {
    id
    employeetype
  }
}
`;

export const leaveConfigurationSubmit =`
mutation CreateLeaveConfig($input: LeaveConfigurationInput!) { 

  createLeaveConfiguration(input: $input) { 

    success 

    message 

    leaveConfiguration { 

      id 

      leaveType 

      numberOfDays 

      period 

      employeeType 

    } 

  } 

} 
`

export const updateLeaveConfiguration=`
mutation UpdateLeaveConfig($id: ID!, $input: LeaveConfigurationInput!) { 

  updateLeaveConfiguration(id: $id, input: $input) { 

    success 

    message 

    leaveConfiguration { 

      id 

      leaveType 

      numberOfDays 

      period 

      employeeType 

    } 

  } 

} 
`


export const getAllLeaveConfiguration =`
query allLeaveConfigurations{ 

  allLeaveConfigurations { 

    id 

    leaveType 

    numberOfDays 

    period 

    employeeType 

  } 

} 
`
export const deleteLeaveConfigurations =`
mutation DeleteLeaveConfig($id: ID!) { 

  deleteLeaveConfiguration(id: $id) { 

    success 

    message 

  } 

} 
`

export const getLeaveConfiguration =`
query GetLeaveConfigById($id: ID!) { 

  leaveConfigurationById(id: $id) { 

    id 

    leaveType 

    numberOfDays 

    period 

    employeeType 

  } 

} 
`